import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const logoutApi = {
  postLogout: () => {
    return instance().post('/logout')
  }
}

export default logoutApi



// WEBPACK FOOTER //
// ./src/api/logout.js